import { webApiService, nativeApiService } from "../core/apiService/";

const apiCall = (
  url: String,
  params: any,
  method: String,
  deviceType: String
) => {
  const apiProvider = getApiProvider(deviceType);
  let result = apiProvider.processAPI(url, params, method);
  return result;
};

const getApiProvider = (deviceType: any) => {
  return deviceType === "NATIVE" ? nativeApiService : webApiService;
};

export const apiService = {
  apiCall,
};
